export function monthlyRate(rate) {
  if (typeof rate !== "string") {
    return "Improper format. Please provide a string."
  }

  if (rate.indexOf("$") === -1) {
    return "Expected value to include $ symbol."
  }

  const number = Math.ceil(parseInt(rate.slice(1), 10) / 12)

  return `$${number}`
}

export function consiceInterval(interval) {
  if (interval === "month") {
    return "mo"
  } else if (interval === "year") {
    return "yr"
  } else {
    return null
  }
}
